export default "__VITE_ASSET__CxMBOn1a__"